module.exports = __webpack_public_path__ + "static/img/oddnary-variation-5.89509c54.jpg";